// extracted by mini-css-extract-plugin
module.exports = {"ProcessOptimizationMonitor":"ProcessOptimizationMonitor_ProcessOptimizationMonitor__3zjae"};